import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#7C3AED',
      light: '#9D5AF5',
      dark: '#5B21B6',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#F59E0B',
      light: '#FBBF24',
      dark: '#D97706',
      contrastText: '#000000',
    },
    info: {
      main: '#06B6D4',
      light: '#22D3EE',
      dark: '#0891B2',
    },
    background: {
      default: '#0F0F1A',
      paper: '#13131F',
    },
    text: {
      primary: '#F1F5F9',
      secondary: '#94A3B8',
    },
    divider: 'rgba(255, 255, 255, 0.08)',
  },
  typography: {
    fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
    h1: {
      fontFamily: "'Poppins', 'Helvetica Neue', Arial, sans-serif",
      fontWeight: 800,
    },
    h2: {
      fontFamily: "'Poppins', 'Helvetica Neue', Arial, sans-serif",
      fontWeight: 700,
    },
    h3: {
      fontFamily: "'Poppins', 'Helvetica Neue', Arial, sans-serif",
      fontWeight: 700,
    },
    h4: {
      fontFamily: "'Poppins', 'Helvetica Neue', Arial, sans-serif",
      fontWeight: 600,
    },
    h5: {
      fontFamily: "'Poppins', 'Helvetica Neue', Arial, sans-serif",
      fontWeight: 600,
    },
    h6: {
      fontFamily: "'Poppins', 'Helvetica Neue', Arial, sans-serif",
      fontWeight: 600,
    },
    button: {
      fontFamily: "'Poppins', 'Helvetica Neue', Arial, sans-serif",
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 50,
          padding: '10px 28px',
          fontSize: '0.95rem',
          fontWeight: 600,
          textTransform: 'none',
          transition: 'all 0.3s ease',
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #7C3AED, #5B21B6)',
          boxShadow: '0 4px 20px rgba(124, 58, 237, 0.4)',
          '&:hover': {
            background: 'linear-gradient(135deg, #9D5AF5, #7C3AED)',
            boxShadow: '0 6px 28px rgba(124, 58, 237, 0.6)',
            transform: 'translateY(-2px)',
          },
        },
        containedSecondary: {
          background: 'linear-gradient(135deg, #F59E0B, #D97706)',
          boxShadow: '0 4px 20px rgba(245, 158, 11, 0.4)',
          color: '#000',
          '&:hover': {
            background: 'linear-gradient(135deg, #FBBF24, #F59E0B)',
            boxShadow: '0 6px 28px rgba(245, 158, 11, 0.6)',
            transform: 'translateY(-2px)',
          },
        },
        outlinedPrimary: {
          borderColor: '#7C3AED',
          color: '#7C3AED',
          '&:hover': {
            background: 'rgba(124, 58, 237, 0.1)',
            borderColor: '#9D5AF5',
            transform: 'translateY(-2px)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: 16,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            background: 'rgba(255, 255, 255, 0.04)',
            borderRadius: 10,
          },
          '& .MuiInputLabel-root': {
            color: '#94A3B8',
          },
          '& .MuiOutlinedInput-input': {
            color: '#F1F5F9',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          background: 'rgba(255, 255, 255, 0.04)',
          borderRadius: 10,
          color: '#F1F5F9',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#0F0F1A',
          scrollBehavior: 'smooth',
        },
      },
    },
  },
});

export default theme;
